import { Button, ButtonTypedButtonProps } from "@/components/Button";
import { useBfState } from "@/helpers/useBfState";
import { CartAddLineItem, setCartAndCheckout } from "@/services/shopifyCart";
import React from "react";

export interface BuyButtonProps extends ButtonTypedButtonProps {
  items: CartAddLineItem[];
  sourceModule?: string;
  discountCode?: string;
}

export const BuyButton = ({
  items,
  sourceModule,
  discountCode,
  disabled,
  ...rest
}: BuyButtonProps) => {
  const [loading, setLoading] = useBfState(false);
  const attemptPurchase = async () => {
    try {
      const discountPromise = discountCode
        ? window.applyDiscount(discountCode)
        : Promise.resolve();
      await discountPromise;
      await setCartAndCheckout(items, sourceModule || "buy-button-unknown");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button
      {...rest}
      loading={loading}
      disabled={disabled || loading}
      onClick={() => {
        setLoading(true);
        attemptPurchase();
      }}
      component="button"
    />
  );
};
